import { render, staticRenderFns } from "./_base-modal.vue?vue&type=template&id=6c4e130b&"
import script from "./_base-modal.vue?vue&type=script&lang=ts&"
export * from "./_base-modal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports